import { useQuery } from "@tanstack/react-query"
import { fetchEcommPurchaseFrequency, type EcommPurchaseFrequencyResponse } from "../services/ecommPurchaseFreqService";


export function useEcommPurchaseFrequency() {
  return useQuery<EcommPurchaseFrequencyResponse>({
    queryKey: ["ecomm-purchase-frequency"],
    queryFn: fetchEcommPurchaseFrequency,
    staleTime: 1000 * 60 * 5,
  });
}
